import { AddCircle, Close, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Card, CardActions, CardContent, CardHeader, Grid, Tooltip } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonButton from 'components/ArgonButton'
import ArgonInput from 'components/ArgonInput'
import ArgonTypography from 'components/ArgonTypography'
import { CustomDescrypt } from 'global/func'
import { postSubmit } from 'global/postFunc'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt'
import { useNavigate } from 'react-router-dom'
import userStore from 'store/userStore'

const Profil = () => {
    const { user, addReq, logOut } = userStore(state => ({ user: state.user, addReq: state.addReq, logOut: state.logOut }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const navigate = useNavigate();
    const [saving, setSaving] = useState(false)
    const [updating, setUpdating] = useState(false)

    const [prevUsername, setPrevUsername] = useState('')
    const [username, setUsername] = useState('')
    const [nama, setNama] = useState('')
    const [nip, setNip] = useState('')
    const [password, setPassword] = useState('')

    const [edit, setEdit] = useState(false)

    const reqAdminData = (username) => {
        addReq()
        postDataWithResponse(
            `/admin-opd/user`,
            {
                username: username
            },
            decryptedUser,
            (res) => {
                setPrevUsername(res.username)
                setUsername(res.username)
                setNama(res.nama)
                setNip(res.nip)
                setPassword(res.password)
            },
            (res) => {
                console.log(res)
            }
        )
    }

    useEffect(() => {
        const decodedUser = decodeToken(decryptedUser)
        console.log(decodedUser);
        reqAdminData(decodedUser.username)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const submit = (e) => {
        const decodedUser = decodeToken(decryptedUser)
        console.log(decodedUser);

        const formData = {
            _method: 'PUT',
            nip: nip,
            nama: nama,
            username: username,
            password: password,
            prevUsername: prevUsername,
            kd_pd: decodedUser.kd_pd
        }

        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/admin-opd/user/update',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                setUpdating(!updating)
                handleLogout(decodedUser.id)
            },
            (res) => {
                setSaving(false)
            }
        )
    }

    const handleLogout = (loginId) => {
        postDataWithResponse(
            '/auth/logout',
            {
                // username: username,
                id: loginId
            },
            null,
            afterSubmit,
            null
        )
    }

    const afterSubmit = (data) => {
        console.log(data);
        if (data > 0) {
            logOut();
            navigate("/", { replace: true });
        }
    }

    return (
        <ArgonBox py={3}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Profil Admin</ArgonTypography>
                        }
                        action={
                            <Tooltip title="Edit">
                                <ArgonButton
                                    variant='contained'
                                    color="primary"
                                    size="small"
                                    startIcon={<AddCircle />}
                                    onClick={() => setEdit(true)}
                                >
                                    Edit
                                </ArgonButton>
                            </Tooltip>
                        }
                    />
                    <CardContent>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Nama
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                disabled={!edit}
                                required
                                size="medium"
                                value={nama}
                                onChange={(e) => setNama(e.target.value)}
                                autoComplete='off'
                            />
                        </ArgonBox>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    NIP
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                disabled={!edit}
                                required
                                size="medium"
                                value={nip}
                                onChange={(e) => setNip(e.target.value)}
                                autoComplete='off'
                            />
                        </ArgonBox>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Username
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                disabled={!edit}
                                required
                                size="medium"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                autoComplete='off'
                            />
                        </ArgonBox>
                        <ArgonBox mb={1}>
                            <ArgonBox mb={1} ml={0.5}>
                                <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                    Password
                                </ArgonTypography>
                            </ArgonBox>
                            <ArgonInput
                                type="text"
                                disabled={!edit}
                                required
                                size="medium"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete='off'
                            />
                        </ArgonBox>
                    </CardContent>
                    <CardActions>
                        <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                            <Grid item>
                                <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={() => setEdit(false)}>Batal</ArgonButton>
                            </Grid>
                            <Grid item>
                                <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving} onClick={submit}>Simpan</LoadingButton>
                            </Grid>
                        </Grid>
                    </CardActions>
                </Card>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Profil